import PropTypes from 'prop-types';

const RegionType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

export default RegionType;



// WEBPACK FOOTER //
// ./client/app/shared/types/region.js